<template>
  <div class="poll-page">
    <div class="toolbar">
      <el-input v-model.trim="keyword" clearable placeholder="活动标题、接龙编号或订单号" @keyup.enter.native="search">
        <el-button slot="append" icon="el-icon-search" @click="search">查询</el-button>
      </el-input>
    </div>

    <el-table v-loading="loading" :data="rows" border stripe>
      <el-table-column prop="title" label="活动标题" min-width="180"/>
      <el-table-column prop="number" label="接龙编号" min-width="170"/>
      <el-table-column label="发起人" min-width="130">
        <template v-slot="scope">{{ (scope.row.initiator && scope.row.initiator.nickname) || '-' }}</template>
      </el-table-column>
      <el-table-column label="发起时间" min-width="165">
        <template v-slot="scope">{{ formatTime(scope.row.initiatedAt) }}</template>
      </el-table-column>
      <el-table-column label="状态" width="90" align="center">
        <template v-slot="scope">
          <el-tag :type="scope.row.status === 'ONGOING' ? 'success' : 'info'">
            {{ scope.row.status === 'ONGOING' ? '进行中' : '已结束' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="orderNumber" label="关联订单号" min-width="150">
        <template v-slot="scope">{{ scope.row.orderNumber || '-' }}</template>
      </el-table-column>
      <el-table-column label="操作" width="100" fixed="right" align="center">
        <template v-slot="scope"><el-button type="text" @click="showDetail(scope.row)">查看投票</el-button></template>
      </el-table-column>
    </el-table>

    <el-pagination class="pagination" background layout="total, prev, pager, next"
                   :total="total" :page-size="pageSize" :current-page.sync="pageCurrent"
                   @current-change="load"/>

    <el-dialog title="活动接龙详情" :visible.sync="detailVisible" width="760px">
      <el-descriptions v-if="detail" :column="2" border>
        <el-descriptions-item label="活动标题">{{ detail.title }}</el-descriptions-item>
        <el-descriptions-item label="接龙编号">{{ detail.number }}</el-descriptions-item>
        <el-descriptions-item label="发起人">{{ (detail.initiator && detail.initiator.nickname) || '-' }}</el-descriptions-item>
        <el-descriptions-item label="截止时间">{{ formatTime(detail.deadline) }}</el-descriptions-item>
        <el-descriptions-item label="状态">{{ detail.status === 'ONGOING' ? '进行中' : '已结束' }}</el-descriptions-item>
        <el-descriptions-item label="关联订单号">{{ detail.orderNumber || '-' }}</el-descriptions-item>
      </el-descriptions>
      <el-table v-if="detail" :data="detail.options || []" border stripe class="option-table">
        <el-table-column label="商品" min-width="180">
          <template v-slot="scope">{{ (scope.row.product && scope.row.product.name) || '商品已下架' }}</template>
        </el-table-column>
        <el-table-column prop="votes" label="票数" width="80" align="center"/>
        <el-table-column prop="rate" label="占比" width="90" align="center"/>
        <el-table-column label="投票人" min-width="260">
          <template v-slot="scope">
            <span v-if="!scope.row.voters || !scope.row.voters.length">-</span>
            <el-tooltip v-for="voter in scope.row.voters" :key="voter.id" :content="voter.nickname || '微信用户'">
              <el-avatar :size="30" :src="voter.avatar" class="voter-avatar">{{ (voter.nickname || '?').slice(0, 1) }}</el-avatar>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import {poll} from "@/api/poll";

export default {
  name: "PollManage",
  data() {
    return {keyword: "", rows: [], total: 0, pageCurrent: 1, pageSize: 20, loading: false, detailVisible: false, detail: null};
  },
  created() { this.load(); },
  methods: {
    search() { this.pageCurrent = 1; this.load(); },
    load() {
      this.loading = true;
      poll.list(this.pageSize, this.pageCurrent, this.keyword)
          .then(res => { this.rows = (res.data && res.data.list) || []; this.total = (res.data && res.data.total) || 0; })
          .finally(() => { this.loading = false; });
    },
    showDetail(row) {
      poll.detail(row.number).then(res => { this.detail = res.data; this.detailVisible = true; });
    },
    formatTime(value) { return value ? new Date(value).toLocaleString("zh-CN", {hour12: false}) : "-"; },
  },
};
</script>

<style scoped>
.poll-page { padding: 20px; }
.toolbar { width: 420px; margin-bottom: 16px; }
.pagination { margin-top: 18px; text-align: right; }
.option-table { margin-top: 18px; }
.voter-avatar { margin-right: 6px; vertical-align: middle; }
</style>
